import React, { useState, useCallback } from "react";
import Button from "common/Button";
import InputWithLabel from "common/InputWithLabel";
import mainTheme from "mainTheme";
// import getIconFromId from "utils/getIconFromId";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import styled, { ThemeProvider } from "styled-components";
import { doLogin } from "utils/api";

const PageHolder = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: column nowrap;
  align-items: center;
`;
const Form = styled.form`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-flow: column nowrap;
  width: calc(100% - 30px);
  max-width: 450px;
  margin-top: 20vh;
`;
const FlexHolder = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;
const LoginTitle = styled.div`
  font-size: 18px;
  margin: 60px 0 30px 0;
`;
const ErrorText = styled.div`
  color: red;
  font-size: 14px;
`;
const CustomLogo = styled.img`
  height: 90px;
`;
const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to right top, ${mainTheme.logoGradient1} 0, ${mainTheme.logoGradient2} 73%, ${mainTheme.logoGradient3});
  width: 206px;
  height: 166px;
`;

export default function LoginPage() {
  const { handleSubmit, register, errors } = useForm();
  const [submitError, setSubmitError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const formatUrl = useCallback(str => {
    const nextUrl = str.split("next=")[1];
    return nextUrl ? decodeURIComponent(nextUrl) : "/map";
  }, []);

  const onSubmit = useCallback(
    async values => {
      try {
        setSubmitting(true);
        await doLogin(values);
        navigate(formatUrl(location.search));
        if (submitError !== "") {
          setSubmitError("");
        }
      } catch (error) {
        setSubmitError(error.msg);
      }
      setSubmitting(false);
    },
    [formatUrl, location.search, navigate, submitError]
  );

  return (
    <ThemeProvider theme={mainTheme}>
      <PageHolder>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <FlexHolder>
            <LogoWrapper>
              <CustomLogo alt="logo" title="logo" src={mainTheme.logoWhite} />
            </LogoWrapper>
            {/* <PageTitle>DAK-bizApp</PageTitle> */}
            <LoginTitle>Anmelden</LoginTitle>
          </FlexHolder>
          <InputWithLabel
            onChange={() => setSubmitError("")}
            reg={register({
              required: "E-Mail erforderlich",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "Ungültige E-Mail-Addesse",
              },
            })}
            name="login"
            type="text"
            label="E-Mail"
            errors={errors}
          />
          <InputWithLabel
            onChange={() => setSubmitError("")}
            name="secret"
            reg={register({
              required: "Passwort erforderlich",
            })}
            type="password"
            label="Passwort"
            errors={errors}
          />

          {submitError && (
            <ErrorText>
              Es tut uns leid, aber entweder die E-Mail-Adresse ist nicht als Account registriert
              oder das eingegebene Passwort ist nicht korrekt. Bitte vergewissern Sie sich, dass
              beides korrekt geschrieben ist.
            </ErrorText>
          )}
          <Button
            disabled={submitting}
            type="submit"
            text="Log in"
            borderRadius="10px"
            width="100%"
            background={mainTheme.interactionColor}
            hoverBackground={mainTheme.interactionColorDark}
            margin="20px 0 0 0"
            title="Log in"
            alt="Log in"
          />
          <a
            title="Passwort vergessen?"
            alt="Passwort vergessen?"
            href={`${process.env.REACT_APP_ADMIN_DOAMIN}/users/password/new`}
            style={{
              textDecoration: "none",
              color: mainTheme.interactionColor,
              textAlign: "center",
              width: "100%",
              marginTop: 5,
            }}
          >
            Passwort vergessen?
          </a>
        </Form>
      </PageHolder>
    </ThemeProvider>
  );
}
